import { createFileRoute } from '@tanstack/react-router';

// Pure grouping layout — no component, so it renders its children directly.
// The workspace resolver and byok flag gate live on the migrated child routes:
// the `$` catch-all renders the embedded host bare (like the settings splat),
// and wrapping it in a resolver or gate would park their SafeNavigate redirects
// with no embedded app mounted to complete them.
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/llm_configuration')({});
